import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import thunk from 'redux-thunk';
import initializers from 'src/modules/initializers';
import createRootReducer from 'src/modules/reducers';

const history = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history,
  savePreviousLocations: 1,
});

let store;

// Redux DevTools setup
const composeEnhancers = 
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export function configureStore(preloadedState?: any) {
  const middlewares = [
    thunk,
    routerMiddleware,
  ].filter(Boolean);

  store = createStore(
    createRootReducer(routerReducer),
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  // Initialize store with initializers
  for (const initializer of initializers) {
    initializer(store);
  }

  return store;
}

// Ensure store is initialized
if (!store) {
  store = configureStore();
}

export const reduxHistory = createReduxHistory(store);

export function getHistory() {
  return reduxHistory;
}

export type AppDispatch = typeof store.dispatch;

export default function getStore() {
  return store;
}